/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { ComplexDependencies } from './dependenciesComplexClass.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createAcos } from '../../factoriesAny.js';
export var acosDependencies = {
  ComplexDependencies,
  typedDependencies,
  createAcos
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesAcos.generated.js
// module id = q8FA
// module chunks = 3